export default __webpack_public_path__ + "static/media/idatacoding-white.572dfe44.svg";